import {api} from '../../../system/api';

export default {
    login: (params) => api.get('login', {params}),
    user: () => api.get('auth/user'),
};
